import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=31afaa58&scoped=true"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31afaa58",
  null
  
)

export default component.exports